import React, { useEffect } from "react";
import RequestsDatatable from "@/Components/Datatables/RequestsDatatable";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import '@/Styles/datatables.scss';
import { Toast } from "primereact/toast";
import { useRef } from "react";

/**
 * Dashboard page
 */
const DashboardPage = () => {
    const toastANRef = useRef();

    useEffect(() => {
        document.title = 'Dashboard' + ' · ' + document.title;
    }, []);

    return (
        <PageLayout>
            <RequestsDatatable />
            <Toast ref={toastANRef} className="cookies-notification" position="top-left" />
        </PageLayout>
    );
};

export default DashboardPage;